import { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import {
  Card,
  Drawer,
  Empty,
  Form,
  List,
  Tabs,
  Tooltip,
  notification,
} from "antd";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "../PartnerManagement/Style.css";
import "./style.css";
import useWindowSize from "../../utils/useWindowSize";
import Logout from "../../containers/Pages/Login/Logout";
import { connect } from "react-redux";
import { useState } from "react";
import { getViewLeadManagmentDetails } from "../../redux/ViewLeadMasterData/action";
import { getLeadDetails } from "../../redux/viewlead/action";
import moment from "moment";
import bactolist from "../../images/back.png";
import useSession from "../CustomLogout/useSession";
import UiButton from "../Common/UiButton/UiButton";
import axios from "axios";
import { FilePdfOutlined } from "@ant-design/icons";
import { mimeTypes } from "../../utils/constants";
import { s3BucketName, s3File_Service } from "../../redux/Url";

const AccessManagement = (props) => {
  const handleSessionExpired = useSession();

  const { TabPane } = Tabs;
  const { leadDoc, leadData } = props;
  const { width } = useWindowSize();
  const history = useNavigate();

  const location = useLocation();
  const id = location?.state?.leadId;

  const [lead, setLead] = useState([]);
  const [leadDisburs, setLeadDisburs] = useState();
  const [coApplicants, setCoApplicants] = useState([]);
  const [leadStatus, setLeadStatus] = useState(null);
  const [leadReason, setLeadReason] = useState(null);
  const [leadValues, setLeadValues] = useState();
  const [openDocument, setOpenDocument] = useState(false);
  const [folderPathValue, setFolderPathValue] = useState(null);
  const [fileList, setFileList] = useState([]);

  const [userRefresh, setUserRefresh] = useState(false);
  const [mode, setMode] = useState("top");
  const handleModeChange = (e) => {
    setMode(e.target.value);
  };
  const adminFirstName = (adminName) => {
    if (adminName) return adminName?.toUpperCase()?.charAt(0);
    else return null;
  };

  const adminLastName = (adminLast) => {
    if (adminLast) return adminLast?.toUpperCase()?.charAt(0);
    else return null;
  };

  useEffect(() => {
    if (props?.leadData?.leadData?.leadDisbursementDetailsDTOList) {
      setLeadDisburs(props?.leadData?.leadData?.leadDisbursementDetailsDTOList);
    }
  }, [leadData, props?.leadData?.leadData?.leadDisbursementDetailsDTOList]);

  useEffect(() => {
    setLead(props?.leadData?.leadData?.dto);
    // setCoApplicants(props?.leadData?.leadData?.dto?.leadCoApplicantList);
  }, [props?.leadData]);

  const createdOn = props.data?.getViewLeadManagementData?.dto?.createdOn;
  const timestamp = new Date(createdOn);

  const formatDate = (timestamp) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(timestamp).toLocaleDateString(undefined, options);
  };

  const datatime = formatDate(lead?.createdOn);

  const crmId = props.data?.getViewLeadManagementData?.dto?.leadCrmId;
  const leadFullName = props.data?.getViewLeadManagementData?.dto?.leadFullName;
  const leadEmail = props.data?.getViewLeadManagementData?.dto?.leadEmail;
  const leadMobile = props.data?.getViewLeadManagementData?.dto?.leadMobile;
  const leadPincode = props.data?.getViewLeadManagementData?.dto?.leadPincode;
  const salesMemberMobile =
    props.data?.getViewLeadManagementData?.dto?.salesMemberMobile;
  const salesMemberEmail =
    props.data?.getViewLeadManagementData?.dto?.salesMemberEmail;
  const salesMemberName =
    props.data?.getViewLeadManagementData?.dto?.salesMemberName;
  const admissionStatusVaue =
    props.data?.getViewLeadManagementData?.dto?.admissionStatusVaue;
  const universityName =
    props.data?.getViewLeadManagementData?.dto?.universityName;
  const countryOfStudy =
    props.data?.getViewLeadManagementData?.dto?.countryOfStudy;
  const instituteName =
    props.data?.getViewLeadManagementData?.dto?.instituteName;
  const courseName = props.data?.getViewLeadManagementData?.dto?.courseName;
  const amountRequested =
    props.data?.getViewLeadManagementData?.dto?.amountRequested;

  const FormItem = Form.Item;

  const [openCallCenter, setOpenCallCenter] = useState(false);
  const [openPartnerNote, setOpenPartnerNote] = useState(false);

  const [leadNotes, setLeadNotes] = useState("");
  const [partnerNotes, setPartnerNotes] = useState("");

  useEffect(() => {
    props
      .getLeadDetails({
        access_token: props?.access_token,
        leadId: id,
      })
      .then((res) => {
        const statusCheck = ["CREDIT_DECLINE", "LEAD_REJECTED"];
        const partnerLeadStatus = res?.data?.dto?.partnerLeadStatus;
        setLeadStatus(partnerLeadStatus);
        setLeadReason(
          statusCheck.includes(partnerLeadStatus)
            ? res?.data?.dto?.reason
            : null
        );
        setLeadValues(res.data.dto);
        setFolderPathValue(res.data.dto?.leadDocumentIdentifier);

        const leadNote = res?.data?.dto?.leadNotes?.replace(/\n/g, "<br>");
        const partnerNote = res?.data?.dto?.partnerNotes?.replace(
          /\n/g,
          "<br>"
        );

        setCoApplicants(props?.leadData?.leadData?.dto?.leadCoApplicantList);
        setLeadNotes(leadNote);
        setPartnerNotes(partnerNote);

        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      });
  }, [id]);

  const handleViewDocument = () => {
    setOpenDocument(true);
  };
  const viewDocumentOnClose = () => {
    setOpenDocument(false);
  };
  const handleViewCallCenter = () => {
    setOpenCallCenter(true);
  };
  const viewCallCenterOnClose = () => {
    setOpenCallCenter(false);
  };
  const handleViewPartnerNote = () => {
    setOpenPartnerNote(true);
  };
  const viewPartnerNoteOnClose = () => {
    setOpenPartnerNote(false);
  };

  const fetchFileList = async () => {
    try {
      const requestBody = {
        bucketName: s3BucketName,
        folderPath: folderPathValue,
      };

      const response = await axios.post(
        `${s3File_Service}/list/all`,
        requestBody,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      setFileList(response.data.response);
      return response.data;
    } catch (error) {
      setFileList([]);
      return null;
    }
  };

  useEffect(() => {
    if (!!folderPathValue) {
      fetchFileList();
    }
  }, [folderPathValue]);

  const documentList = fileList.map((filePath) => {
    const fileName = filePath.split("/").pop();
    return { name: fileName, filePath };
  });

  function base64ToFile(base64String, mimeType, fileName) {
    const base64Data = base64String.replace(/^data:.+;base64,/, "");
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: mimeType });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    link.click();

    URL.revokeObjectURL(url);
  }

  const handleViewFile = async (filePath) => {
    try {
      const body = {
        bucketName: s3BucketName,
        filePath: filePath,
      };

      const response = await axios.post(
        `${s3File_Service}/download/file`,
        body,
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      const filepath = JSON.parse(response.config.data);
      const filename = filepath.filePath.split("/").pop();
      const filetype =
        mimeTypes[filename.toLowerCase()] || "application/octet-stream";

      base64ToFile(response.data, filetype, filename);
    } catch (error) {
      console.error("Error fetching file:", error);
    }
  };

  function goLeadDoc() {
    history(`/leadManagementDashboard/addLeadDoc/${id}`, {
      state: { leadDisable: true },
    });
  }

  function formatText(text) {
    return text
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ")
      .toUpperCase();
  }

  return (
    <div className="" style={{ maxWidth: "100%" }}>
      {width < 786 && (
        <Row>
          <Col lg={12} xs={12} md={12} sm={12}></Col>
        </Row>
      )}

      {width > 786 && (
        <Row>
          <Col lg={12} xs={12} md={12} sm={12} className="partnerHeadre">
            <Col md={8} className="search-bar"></Col>

            <Col md={4}>
              <div className="login-profie">
                <div className="img-sec">
                  <h2>
                    {adminFirstName(
                      props.userDetail?.firstName ??
                        props.userDetail?.userName?.split(" ")[0]?.trim()
                    )}
                  </h2>
                  <h2>
                    {adminLastName(
                      props.userDetail?.lastName ??
                        props.userDetail?.userName?.split(" ")[1]?.trim()
                    )}
                  </h2>
                </div>

                <div className="content-login">
                  <h4>{props.userDetail?.userName}</h4>
                  <h5>{props.userDetail?.roleName}</h5>
                  <div className="content-login-data">
                    {/* <ChangePassword /> */}
                    <div className="admin-small-space"> </div>
                    <Logout />
                    {/* <h6>Change Password | Logout</h6> */}
                  </div>
                </div>
              </div>
            </Col>
          </Col>
        </Row>
      )}

      <div className="view-lead-sec">
        <Row>
          <div class="bredcrumbs">
            <Link
              className="ListItem"
              to="/leadManagementDashboard/leadManagement"
            >
              <img src={bactolist} alt="" />
            </Link>
            <UiButton
              title="Call Center Notes"
              onClick={() => {
                handleViewCallCenter();
              }}
              className="Addleadmain"
            />

            <UiButton
              title="Partner Notes"
              onClick={() => {
                handleViewPartnerNote();
              }}
              className="Addleadmain"
            />
            <UiButton
              title="View Documents"
              onClick={() => {
                handleViewDocument();
              }}
              className="Addleadmain"
            />
            {/* <div>
              <h3 class="sec-heading">Lead Managment {">"} Lead Deatils</h3>
              <div class="headre-line"></div>
            </div> */}
          </div>
        </Row>

        <Drawer
          title="Details Drawer"
          placement="right"
          onClose={viewDocumentOnClose}
          open={openDocument}
          className="drawer-main-sec drawer-footer"
          width="42rem"
        >
          <h1 style={{ paddingLeft: "14px" }}>List of Documents</h1>

          {documentList.length > 0 ? (
            <List
              dataSource={documentList}
              renderItem={(item) => (
                <Card style={{ marginBottom: 14, borderRadius: 8 }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <FilePdfOutlined
                        style={{ fontSize: 20, marginRight: 10 }}
                      />
                      <div>
                        <div style={{ fontWeight: "bold" }}>{item.name}</div>
                        <span
                          style={{ color: "#b42bb4", cursor: "pointer" }}
                          onClick={() => handleViewFile(item.filePath)}
                        >
                          Click to download
                        </span>
                      </div>
                    </div>
                  </div>
                </Card>
              )}
            />
          ) : (
            <Empty />
          )}
        </Drawer>
        <Drawer
          title="Details Drawer"
          placement="right"
          onClose={viewCallCenterOnClose}
          open={openCallCenter}
          className="drawer-main-sec drawer-footer"
          width="42rem"
        >
          <h1 style={{ paddingLeft: "14px" }}>Call Center Notes</h1>

          <div
            style={{ paddingLeft: "14px" }}
            dangerouslySetInnerHTML={{
              __html: leadNotes ? leadNotes : "",
            }}
          />
          {!leadNotes && <Empty />}
        </Drawer>

        <Drawer
          title="Details Drawer"
          placement="right"
          onClose={viewPartnerNoteOnClose}
          open={openPartnerNote}
          className="drawer-main-sec drawer-footer"
          width="42rem"
        >
          <h1 style={{ paddingLeft: "14px" }}>Partner Notes</h1>

          <div
            style={{ paddingLeft: "14px" }}
            dangerouslySetInnerHTML={{
              __html: partnerNotes ? partnerNotes : "",
            }}
          />
          {!partnerNotes && <Empty />}
        </Drawer>

        <Row className="inner-text-lead">
          <Col lg={12} xs={12} md={12} sm={12} className="view-lead-sec-box">
            <Col md={5} className="grey-box-sec">
              <div className="boxpatch">
                <div className="content-text-lead">
                  <div className="inner-text-lead">
                    <h3 className="crminfo">
                      CRM ID:
                      <span className="lead-sub-text">
                        {leadValues?.leadCrmId
                          ? leadValues?.leadCrmId
                          : "------"}
                      </span>
                    </h3>
                    <h3 className="crminfo">
                      LEAD CODE:
                      <span className="lead-sub-text">
                        {leadValues?.leadCode ? leadValues?.leadCode : "------"}
                      </span>
                    </h3>
                    <h3 className="crminfo">
                      LAN NUMBER:
                      <span className="lead-sub-text">
                        {leadValues?.lanNumber
                          ? leadValues?.lanNumber
                          : "------"}
                      </span>
                    </h3>
                    <h2>
                      {leadValues?.leadFullName &&
                      leadValues?.leadFullName.length > 22 ? (
                        <Tooltip title={leadValues?.leadFullName}>
                          {leadValues?.leadFullName.slice(0, 22) + "..."}
                        </Tooltip>
                      ) : (
                        leadValues?.leadFullName || "------"
                      )}
                    </h2>
                  </div>
                </div>
              </div>
              <div className="content-text-lead">
                <div className="inner-text-lead">
                  <h3>Email Address</h3>
                  <h2>
                    {leadValues?.leadEmail ? leadValues?.leadEmail : "------"}
                  </h2>
                </div>
                <div className="inner-text-lead">
                  <h3>Mobile Number </h3>
                  <h2>
                    {leadValues?.leadMobile ? leadValues?.leadMobile : "------"}
                  </h2>
                </div>
                <div className="inner-text-lead">
                  <h3>PAN Number </h3>
                  <h2>
                    {leadValues?.leadPancardNo
                      ? leadValues?.leadPancardNo
                      : "------"}
                  </h2>
                </div>
                <div className="inner-text-lead">
                  <h3>Passport Number </h3>
                  <h2>
                    {leadValues?.leadPassportNo
                      ? leadValues?.leadPassportNo
                      : "------"}
                  </h2>
                </div>
                <div className="inner-text-lead">
                  <h3>Address</h3>
                  <h2>
                    {`${leadValues?.leadCityName || "------"} 
                      ${leadValues?.leadStateName || "------"} 
                      ${leadValues?.leadPincode || "------"}`}
                  </h2>
                </div>
                <div className="inner-text-lead">
                  <h3>Customer Pincode </h3>
                  <h2>
                    {leadValues?.leadPincode
                      ? leadValues?.leadPincode
                      : "------"}
                  </h2>
                </div>
                <div className="inner-text-lead">
                  <h3>Contact Center Qualification </h3>
                  <h2>
                    {leadValues &&
                    leadValues.contactCenterQualification !== undefined
                      ? leadValues.contactCenterQualification
                        ? "Yes"
                        : "No"
                      : leadValues &&
                        leadValues.contactCenterQualification === null
                      ? "------"
                      : "------"}
                  </h2>
                </div>
                <div className="inner-text-lead">
                  <h3>Student Document Upload </h3>
                  <h2>
                    {leadValues && leadValues.uploadDocuments !== undefined
                      ? leadValues.uploadDocuments
                        ? "Yes"
                        : "No"
                      : leadValues && leadValues.uploadDocuments === null
                      ? "------"
                      : "------"}
                  </h2>
                </div>
                <hr />
                <div className="inner-text-blue">
                  <h3>SALES TEAM MEMBER</h3>
                  <h2>
                    {leadValues?.salesMemberName
                      ? leadValues?.salesMemberName
                      : "------"}
                  </h2>
                  <h2>
                    {leadValues?.salesMemberEmail
                      ? leadValues?.salesMemberEmail
                      : "------"}
                  </h2>
                  <h2>
                    {leadValues?.salesMemberMobile
                      ? leadValues?.salesMemberMobile
                      : "------"}
                  </h2>
                </div>
                <hr />
                <div className="inner-text-blue">
                  <h3>SALES EXECUTIVE MEMBER</h3>
                  <h2>
                    {leadValues?.salesExecutiveName
                      ? leadValues?.salesExecutiveName
                      : "------"}
                  </h2>
                  <h2>
                    {leadValues?.salesExecutiveEmail
                      ? leadValues?.salesExecutiveEmail
                      : "------"}
                  </h2>
                  <h2>
                    {leadValues?.salesExecutiveMobile
                      ? leadValues?.salesExecutiveMobile
                      : "------"}
                  </h2>
                </div>

                <hr />
                <div className="inner-text-lead">
                  <h3>Code Created On </h3>
                  <h2>
                    {leadValues?.createdOn
                      ? moment(leadValues.createdOn).format("DD/MM/YY, hh:mmA")
                      : "------"}
                  </h2>
                </div>
                <hr />
              </div>
            </Col>

            <Col md={7} className="lead-right-sec">
              <Row>
                <Col
                  lg={12}
                  xs={12}
                  md={12}
                  sm={12}
                  className="view-lead-sec-box"
                >
                  <Col md={12} className="grey-box-sec">
                    <div className="display-lead-status">
                      <h3>lead status</h3>
                      <span className={leadStatus ? "txt-incomplete" : ""}>
                        {leadStatus ? formatText(leadStatus) : "------"}
                      </span>
                    </div>
                  </Col>
                </Col>
              </Row>
              <Row>
                <Col
                  lg={12}
                  xs={12}
                  md={12}
                  sm={12}
                  className="view-lead-sec-box"
                >
                  <Col md={12} className="grey-box-sec">
                    <div className="display-lead-status">
                      <h3>Reason</h3>
                      <span>{leadReason ? leadReason : "------"}</span>
                    </div>
                  </Col>
                </Col>
              </Row>
              <br />
              <div className="content-right-side">
                {/* <Row>
                  <Col md={5}>
                    <h3>Uploaded Documents </h3>
                  </Col>

                </Row> */}

                {/* 
                <Row>
                  <Col className='AddCoAppBtn' md={2}>
                    <UiButton type="button" title="Lead Documents" onClick={goLeadDoc} />
                  </Col>

                </Row>
                <br></br> */}

                {/* <Row>
                  <Col
                    lg={12}
                    xs={12}
                    md={12}
                    sm={12}
                    className="view-lead-sec-box"
                  >
                    <Col md={12} className="grey-box-sec">
                      <div className="inner-text-lead">
                        <h3>CO--APPLICANT DETAILS</h3>
                      </div>
                    </Col>
                  </Col>
                </Row>
                <Row>
                  <Col
                    lg={12}
                    xs={12}
                    md={12}
                    sm={12}
                    className="view-lead-sec-box"
                  >
                    <Col md={12} className="grey-box-sec">
                      {coApplicants ? (
                        <div>
                          {coApplicants?.length === 0 ? (
                            <div className="">
                              <h3 className="doc-uploadtext">
                                No coApplicants
                              </h3>
                            </div>
                          ) : (
                            // Assuming 'coApplicants' is an array with co-applicant data
                            // Each coApplicant object should have properties like 'firstName', 'lastName', 'mobileNo', 'emailAddress'

                            // ... (existing code)

                            <Tabs>
                              {coApplicants.map((coApp, coAppIndex) => (
                                <TabPane
                                  key={coAppIndex}
                                  tab={`CoApplicant ${coAppIndex + 1}`}
                                >
                                  <div>
                                    <h4>
                                      Name:{" "}
                                      {`${coApp.firstName} ${coApp.lastName}`}
                                    </h4>
                                    <p>Mobile No: {coApp?.mobileNo}</p>
                                    <p>Email: {coApp?.emailAddress}</p>
                                    <p>Relationship: {coApp?.relationship}</p>
                                    <p>
                                      Income To Be Considered:{" "}
                                      {coApp?.incomeTobeConsideredFlag
                                        ? "true"
                                        : "false"}
                                    </p>
                                  </div>
                                </TabPane>
                              ))}
                            </Tabs>
                          )}
                        </div>
                      ) : (
                        <div className="">
                          <h3 className="doc-uploadtext">NO COAPPLICANTS</h3>
                        </div>
                      )}
                    </Col>
                  </Col>
                </Row>
                <br></br>
                <br></br> */}
                <div className="text-box-admission">
                  <h3>ADMISSION INFO</h3>
                </div>
              </div>
              <Row>
                <Col
                  lg={12}
                  xs={12}
                  md={12}
                  sm={12}
                  className="view-lead-sec-box"
                >
                  <Col md={6} className="grey-box-sec">
                    <div className="inner-text-lead">
                      <h3>Admission Status </h3>
                      <h2>
                        {leadValues?.admissionStatusVaue
                          ? leadValues?.admissionStatusVaue
                          : "------"}
                      </h2>
                    </div>
                  </Col>
                  <Col md={6} className="grey-box-sec"></Col>
                </Col>
              </Row>
              <Row>
                <Col
                  lg={12}
                  xs={12}
                  md={12}
                  sm={12}
                  className="view-lead-sec-box"
                >
                  <Col md={7} className="grey-box-sec">
                    <div className="inner-text-lead">
                      <h3>Month Of Admission Intake</h3>
                      <h2>
                        {leadValues?.leadMonthOfAddmissionIntake
                          ? leadValues?.leadMonthOfAddmissionIntake
                          : "------"}
                      </h2>
                    </div>
                  </Col>
                  <Col md={5} className="grey-box-sec">
                    <div className="inner-text-lead">
                      <h3>Course Type</h3>
                      <h2>
                        {leadValues?.leadCourseTypeNameValue
                          ? leadValues?.leadCourseTypeNameValue
                          : "------"}
                      </h2>
                    </div>
                  </Col>
                </Col>
              </Row>
              <Row>
                <Col
                  lg={12}
                  xs={12}
                  md={12}
                  sm={12}
                  className="view-lead-sec-box"
                >
                  <Col md={6} className="grey-box-sec">
                    <div className="inner-text-lead">
                      <h3>Loan Type</h3>
                      <h2>
                        {leadValues?.leadLoanTypeValue
                          ? leadValues?.leadLoanTypeValue
                          : "------"}
                      </h2>
                    </div>
                  </Col>
                  <Col md={6} className="grey-box-sec"></Col>
                </Col>
              </Row>
              <Row>
                <Col
                  lg={12}
                  xs={12}
                  md={12}
                  sm={12}
                  className="view-lead-sec-box"
                >
                  <Col md={7} className="grey-box-sec">
                    <div className="inner-text-lead">
                      <h3>Country of Study</h3>
                      <h2>
                        {leadValues?.countryOfStudy
                          ? leadValues?.countryOfStudy
                          : "------"}
                      </h2>
                    </div>
                  </Col>
                  <Col md={5} className="grey-box-sec">
                    <div className="inner-text-lead">
                      <h3>University </h3>
                      <h2>
                        {leadValues?.universityName ||
                          leadValues?.otherUniversity ||
                          "-----"}
                      </h2>
                    </div>
                  </Col>
                </Col>
              </Row>
              <Row>
                <Col
                  lg={12}
                  xs={12}
                  md={12}
                  sm={12}
                  className="view-lead-sec-box"
                >
                  <Col md={7} className="grey-box-sec">
                    <div className="inner-text-lead">
                      <h3>School/Institute</h3>
                      <h2>
                        {leadValues?.instituteName ||
                          leadValues?.otherInstitute ||
                          "-----"}
                      </h2>
                    </div>
                  </Col>
                  <Col md={5} className="grey-box-sec">
                    <div className="inner-text-lead">
                      <h3>Amount Requested </h3>
                      <h2>
                        {leadValues?.amountRequested
                          ? new Intl.NumberFormat("en-IN").format(
                              leadValues?.amountRequested
                            )
                          : "------"}
                      </h2>
                    </div>
                  </Col>
                </Col>
              </Row>
              <Row>
                <Col
                  lg={12}
                  xs={12}
                  md={12}
                  sm={12}
                  className="view-lead-sec-box"
                >
                  <Col md={7} className="grey-box-sec">
                    <div className="inner-text-lead">
                      <h3>Course </h3>
                      <h2>
                        {leadValues?.courseName ||
                          leadValues?.otherCourse ||
                          "-----"}
                      </h2>
                    </div>
                  </Col>
                  <Col md={5} className="grey-box-sec">
                    <div className="inner-text-lead">
                      <h3>Stem</h3>
                      <h2>
                        {leadValues?.stemCourse
                          ? "Yes"
                          : leadValues?.stemCourse == false
                          ? "No"
                          : "-----"}
                      </h2>
                    </div>
                  </Col>
                </Col>
              </Row>
              {/* <Row>
                <Col
                  lg={12}
                  xs={12}
                  md={12}
                  sm={12}
                  className="view-lead-sec-box"
                >
                  <Col md={12} className="grey-box-sec">
                    <div className="inner-text-lead">
                      <h3>DOCUMENT UPLOAD DETAILS </h3>
                    </div>
                  </Col>
                </Col>
              </Row> */}
              {/* <Row>
                <Col
                  lg={12}
                  xs={12}
                  md={12}
                  sm={12}
                  className="view-lead-sec-box"
                >
                  <Col md={12} className="grey-box-sec">
                    {leadDoc ? (
                      <div>
                        {leadDoc?.length === 0 ? (
                          <div className="">
                            <h3 className="doc-uploadtext">
                              Documents Not Uploaded
                            </h3>
                          </div>
                        ) : (
                          <Tabs defaultActiveKey="kyc">
                            <TabPane tab="Student KYC Documents" key="kyc">
                              {leadDoc
                                .filter(
                                  (item) =>
                                    item.section === "STUDENT_KYC_DOCUMENTS"
                                )
                                .map((item, index) => (
                                  <div
                                    style={{ wordBreak: "break-all" }}
                                    key={index}
                                  >
                                    {item.fileName}
                                  </div>
                                ))}
                            </TabPane>
                            {leadDoc.some(
                              (item) =>
                                item.section === "STUDENT_EDUCATION_DETAILS"
                            ) && (
                                <TabPane
                                  tab="Student Education Details"
                                  key="edu"
                                >
                                  {leadDoc
                                    .filter(
                                      (item) =>
                                        item.section ===
                                        "STUDENT_EDUCATION_DETAILS"
                                    )
                                    .map((item, index) => (
                                      <div
                                        style={{ wordBreak: "break-all" }}
                                        key={index}
                                      >
                                        {item.fileName}
                                      </div>
                                    ))}
                                </TabPane>
                              )}
                            {leadDoc.some(
                              (item) =>
                                item.section === "STUDENT_BANK_DOCUMENTS"
                            ) && (
                                <TabPane tab="Student Bank Details" key="bank">
                                  {leadDoc
                                    .filter(
                                      (item) =>
                                        item.section === "STUDENT_BANK_DOCUMENTS"
                                    )
                                    .map((item, index) => (
                                      <div
                                        style={{ wordBreak: "break-all" }}
                                        key={index}
                                      >
                                        {item.fileName}
                                      </div>
                                    ))}
                                </TabPane>
                              )}

                            {leadDoc.some(
                              (item) =>
                                item.section === "STUDENT_INCOME_DOCUMENTS"
                            ) && (
                                <TabPane
                                  tab="Student Income Details"
                                  key="icnome"
                                >
                                  {leadDoc
                                    .filter(
                                      (item) =>
                                        item.section ===
                                        "STUDENT_INCOME_DOCUMENTS"
                                    )
                                    .map((item, index) => (
                                      <div
                                        style={{ wordBreak: "break-all" }}
                                        key={index}
                                      >
                                        {item.fileName}
                                      </div>
                                    ))}
                                </TabPane>
                              )}
                          </Tabs>
                        )}
                      </div>
                    ) : (
                      <div className="">
                        <h3 className="doc-uploadtext">
                          Documents Not Uploaded
                        </h3>
                      </div>
                    )}
                  </Col>
                </Col>
              </Row> */}
              <br></br>
              <br></br>

              <Row>
                <Col
                  lg={12}
                  xs={12}
                  md={12}
                  sm={12}
                  className="view-lead-sec-box"
                >
                  <Col md={12} className="grey-box-sec">
                    <div className="inner-text-lead">
                      <h3>LEAD DISBURSEMENT DETAILS </h3>
                    </div>
                  </Col>
                </Col>
              </Row>
              <Row>
                <div className="disbrt-table-sec">
                  <table className="disbrt-table">
                    <thead>
                      <tr>
                        <th>Disbursement Amount</th>
                        <th>Disbursement Date Time</th>
                        <th>Disbursement Status</th>
                        <th>Lan Number</th>
                      </tr>
                    </thead>
                    <tbody>
                      {leadDisburs && leadDisburs.length > 0 ? (
                        leadDisburs.map((detail, index) => (
                          <tr key={index}>
                            <td>{detail.disbursementAmount}</td>
                            <td>{detail.disbursementDateTime}</td>
                            <td>{detail.disbursementStatus}</td>
                            <td>{detail.lanNumber}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="4">No data available</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </Row>
            </Col>
          </Col>
        </Row>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    userDetail: state.auth?.userData,
    access_token: state && state.auth && state.auth.idToken,
    data: state.getViewLeadManagement,
    leadData: state.viewLead,
    leadDoc: state.viewLead.leadData.viewLeadDocumentsDTOList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getViewLeadManagmentDetails: (data) =>
      dispatch(getViewLeadManagmentDetails(data)),
    getLeadDetails: (data) => dispatch(getLeadDetails(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AccessManagement);
